import { ChartOption, ReportResult } from "../entities/reportEntity";
import { isEmpty } from "@/utils/Common";

export default function (definition: any, chartOption: ChartOption, datas: ReportResult) {
  const xaxisLabels: Array<string> = [];
  for (let i = 0; i < datas.colCount; i++) {
    if (datas.colDimNodes[i][0].total) {
      continue;
    }
    xaxisLabels.push(datas.colDimNodes[i][0].label);
  }

  const yaxisLabels: Array<string> = [];
  for (let i = 0; i < datas.rowCount; i++) {
    if (datas.rowDimNodes[i][0].total) {
      continue;
    }
    yaxisLabels.push(datas.rowDimNodes[i][0].label);
  }

  let max = 0;
  const data: Array<Array<any>> = [];
  for (let i = 0; i < xaxisLabels.length; i++) {
    for (let j = 0; j < yaxisLabels.length; j++) {
      let count = 0;
      if (datas.dataValues[datas.rowColIndexes[j][i]]) {
        count = datas.dataValues[datas.rowColIndexes[j][i]][0];
      }
      if (max < count) {
        max = count;
      }
      data.push([i, j, count || "-"]);
    }
  }

  const option: any = {
    tooltip: {
      position: "right",
      trigger: "item",
      formatter: function (params: any) {
        const data = params.data || [];
        return (
          definition.colDims[0].label +
          ": " +
          xaxisLabels[data[0]] +
          "<br/>" +
          definition.rowDims[0].label +
          ": " +
          yaxisLabels[data[1]] +
          "<br/>" +
          definition.measures[0].label +
          ": " +
          data[2]
        );
      },
    },
    grid: {
      top: "12%",
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: xaxisLabels,
      splitArea: {
        show: true,
      },
    },
    yAxis: {
      type: "category",
      data: yaxisLabels,
      splitArea: {
        show: true,
      },
    },
    visualMap: {
      min: 0,
      max: max,
      calculable: true,
      orient: "horizontal",
      left: "center",
      // bottom: '-6%',
      inRange: {
        color: ["#ffffff", "#BF444C"],
      },
    },
    series: [
      {
        name: "热力图",
        type: "heatmap",
        data: data,
        label: {
          normal: {
            show: true,
          },
        },
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  if (!chartOption.hideTitle && !isEmpty(chartOption.title)) {
    option.title = {
      left: "center",
      text: chartOption.title,
    };
    if (!isEmpty(chartOption.subTitle)) {
      option.title.subtext = chartOption.subTitle;
    }
  }

  if (!chartOption.hideToolbox) {
    option.enableSwitchXY = true;
    option.toolbox = {
      show: true,
      feature: {
        saveAsImage: {},
      },
    };
  }

  return option;
}
